import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["value", "defaultValue", "onChange", "name", "by", "disabled", "__demoMode", "nullable", "multiple"],
    _excluded2 = ["id", "onChange", "displayValue", "type"],
    _excluded3 = ["id"],
    _excluded4 = ["id"],
    _excluded5 = ["id", "hold"],
    _excluded6 = ["id", "disabled", "value"];

var _He;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import z, { Fragment as me, createContext as ue, createRef as xe, useCallback as Ce, useContext as pe, useEffect as se, useMemo as D, useReducer as Oe, useRef as E } from "react";
import { useComputed as te } from '../../hooks/use-computed.js';
import { useDisposables as ne } from '../../hooks/use-disposables.js';
import { useEvent as x } from '../../hooks/use-event.js';
import { useId as K } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as M } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as ge } from '../../hooks/use-latest-value.js';
import { useOutsideClick as ye } from '../../hooks/use-outside-click.js';
import { useResolveButtonType as Re } from '../../hooks/use-resolve-button-type.js';
import { useSyncRefs as W } from '../../hooks/use-sync-refs.js';
import { useTreeWalker as ve } from '../../hooks/use-tree-walker.js';
import { calculateActiveIndex as Pe, Focus as R } from '../../utils/calculate-active-index.js';
import { disposables as be } from '../../utils/disposables.js';
import { forwardRefWithAs as k, render as w, compact as Ae, Features as de } from '../../utils/render.js';
import { isDisabledReactIssue7711 as Ee } from '../../utils/bugs.js';
import { match as U } from '../../utils/match.js';
import { objectToFormEntries as Se } from '../../utils/form.js';
import { sortByDomNode as Ie } from '../../utils/focus-management.js';
import { Hidden as Le, Features as Ve } from '../../internal/hidden.js';
import { useOpenClosed as De, State as ee, OpenClosedProvider as Fe } from '../../internal/open-closed.js';
import { Keys as A } from '../keyboard.js';
import { useControllable as Me } from '../../hooks/use-controllable.js';
import { useWatch as fe } from '../../hooks/use-watch.js';
import { useTrackedPointer as _e } from '../../hooks/use-tracked-pointer.js';
import { isMobile as he } from '../../utils/platform.js';

var Be = function (e) {
  return e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e;
}(Be || {}),
    ke = function (e) {
  return e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e;
}(ke || {}),
    we = function (e) {
  return e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e;
}(we || {}),
    Ue = function (n) {
  return n[n.OpenCombobox = 0] = "OpenCombobox", n[n.CloseCombobox = 1] = "CloseCombobox", n[n.GoToOption = 2] = "GoToOption", n[n.RegisterOption = 3] = "RegisterOption", n[n.UnregisterOption = 4] = "UnregisterOption", n[n.RegisterLabel = 5] = "RegisterLabel", n;
}(Ue || {});

function re(t) {
  var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (e) {
    return e;
  };
  var e = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null,
      r = Ie(l(t.options.slice()), function (s) {
    return s.dataRef.current.domRef.current;
  }),
      i = e ? r.indexOf(e) : null;
  return i === -1 && (i = null), {
    options: r,
    activeOptionIndex: i
  };
}

var He = (_He = {}, _defineProperty(_He, 1, function _(t) {
  var l;
  return (l = t.dataRef.current) != null && l.disabled || t.comboboxState === 1 ? t : _objectSpread(_objectSpread({}, t), {}, {
    activeOptionIndex: null,
    comboboxState: 1
  });
}), _defineProperty(_He, 0, function _(t) {
  var e;
  if ((e = t.dataRef.current) != null && e.disabled || t.comboboxState === 0) return t;
  var l = t.activeOptionIndex;

  if (t.dataRef.current) {
    var r = t.dataRef.current.isSelected,
        i = t.options.findIndex(function (s) {
      return r(s.dataRef.current.value);
    });
    i !== -1 && (l = i);
  }

  return _objectSpread(_objectSpread({}, t), {}, {
    comboboxState: 0,
    activeOptionIndex: l
  });
}), _defineProperty(_He, 2, function _(t, l) {
  var i, s, n, d;
  if ((i = t.dataRef.current) != null && i.disabled || (s = t.dataRef.current) != null && s.optionsRef.current && !((n = t.dataRef.current) != null && n.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
  var e = re(t);

  if (e.activeOptionIndex === null) {
    var o = e.options.findIndex(function (u) {
      return !u.dataRef.current.disabled;
    });
    o !== -1 && (e.activeOptionIndex = o);
  }

  var r = Pe(l, {
    resolveItems: function resolveItems() {
      return e.options;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return e.activeOptionIndex;
    },
    resolveId: function resolveId(o) {
      return o.id;
    },
    resolveDisabled: function resolveDisabled(o) {
      return o.dataRef.current.disabled;
    }
  });
  return _objectSpread(_objectSpread(_objectSpread({}, t), e), {}, {
    activeOptionIndex: r,
    activationTrigger: (d = l.trigger) != null ? d : 1
  });
}), _defineProperty(_He, 3, function _(t, l) {
  var s, n;
  var e = {
    id: l.id,
    dataRef: l.dataRef
  },
      r = re(t, function (d) {
    return [].concat(_toConsumableArray(d), [e]);
  });
  t.activeOptionIndex === null && (s = t.dataRef.current) != null && s.isSelected(l.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(e));

  var i = _objectSpread(_objectSpread(_objectSpread({}, t), r), {}, {
    activationTrigger: 1
  });

  return (n = t.dataRef.current) != null && n.__demoMode && t.dataRef.current.value === void 0 && (i.activeOptionIndex = 0), i;
}), _defineProperty(_He, 4, function _(t, l) {
  var e = re(t, function (r) {
    var i = r.findIndex(function (s) {
      return s.id === l.id;
    });
    return i !== -1 && r.splice(i, 1), r;
  });
  return _objectSpread(_objectSpread(_objectSpread({}, t), e), {}, {
    activationTrigger: 1
  });
}), _defineProperty(_He, 5, function _(t, l) {
  return _objectSpread(_objectSpread({}, t), {}, {
    labelId: l.id
  });
}), _He),
    ae = ue(null);
ae.displayName = "ComboboxActionsContext";

function $(t) {
  var l = pe(ae);

  if (l === null) {
    var e = new Error("<".concat(t, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(e, $), e;
  }

  return l;
}

var le = ue(null);
le.displayName = "ComboboxDataContext";

function H(t) {
  var l = pe(le);

  if (l === null) {
    var e = new Error("<".concat(t, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(e, H), e;
  }

  return l;
}

function Ne(t, l) {
  return U(l.type, He, t, l);
}

var Ge = me;

function Xe(t, l) {
  var _U3;

  var e = t.value,
      r = t.defaultValue,
      i = t.onChange,
      s = t.name,
      _t$by = t.by,
      n = _t$by === void 0 ? function (p, T) {
    return p === T;
  } : _t$by,
      _t$disabled = t.disabled,
      d = _t$disabled === void 0 ? !1 : _t$disabled,
      _t$__demoMode = t.__demoMode,
      o = _t$__demoMode === void 0 ? !1 : _t$__demoMode,
      _t$nullable = t.nullable,
      u = _t$nullable === void 0 ? !1 : _t$nullable,
      _t$multiple = t.multiple,
      P = _t$multiple === void 0 ? !1 : _t$multiple,
      f = _objectWithoutProperties(t, _excluded),
      _Me = Me(e, i, r),
      _Me2 = _slicedToArray(_Me, 2),
      _Me2$ = _Me2[0],
      O = _Me2$ === void 0 ? P ? [] : void 0 : _Me2$,
      m = _Me2[1],
      _Oe = Oe(Ne, {
    dataRef: xe(),
    comboboxState: o ? 0 : 1,
    options: [],
    activeOptionIndex: null,
    activationTrigger: 1,
    labelId: null
  }),
      _Oe2 = _slicedToArray(_Oe, 2),
      g = _Oe2[0],
      c = _Oe2[1],
      C = E(!1),
      N = E({
    static: !1,
    hold: !1
  }),
      F = E(null),
      _ = E(null),
      h = E(null),
      B = E(null),
      V = x(typeof n == "string" ? function (p, T) {
    var v = n;
    return (p == null ? void 0 : p[v]) === (T == null ? void 0 : T[v]);
  } : n),
      G = Ce(function (p) {
    var _U;

    return U(b.mode, (_U = {}, _defineProperty(_U, 1, function _() {
      return O.some(function (T) {
        return V(T, p);
      });
    }), _defineProperty(_U, 0, function _() {
      return V(O, p);
    }), _U));
  }, [O]),
      b = D(function () {
    return _objectSpread(_objectSpread({}, g), {}, {
      optionsPropsRef: N,
      labelRef: F,
      inputRef: _,
      buttonRef: h,
      optionsRef: B,
      value: O,
      defaultValue: r,
      disabled: d,
      mode: P ? 1 : 0,

      get activeOptionIndex() {
        if (C.current && g.activeOptionIndex === null && g.options.length > 0) {
          var p = g.options.findIndex(function (T) {
            return !T.dataRef.current.disabled;
          });
          if (p !== -1) return p;
        }

        return g.activeOptionIndex;
      },

      compare: V,
      isSelected: G,
      nullable: u,
      __demoMode: o
    });
  }, [O, r, d, P, u, o, g]),
      L = E(b.activeOptionIndex !== null ? b.options[b.activeOptionIndex] : null);

  se(function () {
    var p = b.activeOptionIndex !== null ? b.options[b.activeOptionIndex] : null;
    L.current !== p && (L.current = p);
  }), M(function () {
    g.dataRef.current = b;
  }, [b]), ye([b.buttonRef, b.inputRef, b.optionsRef], function () {
    return oe.closeCombobox();
  }, b.comboboxState === 0);
  var y = D(function () {
    return {
      open: b.comboboxState === 0,
      disabled: d,
      activeIndex: b.activeOptionIndex,
      activeOption: b.activeOptionIndex === null ? null : b.options[b.activeOptionIndex].dataRef.current.value,
      value: O
    };
  }, [b, d, O]),
      a = x(function (p) {
    var T = b.options.find(function (v) {
      return v.id === p;
    });
    T && j(T.dataRef.current.value);
  }),
      I = x(function () {
    if (b.activeOptionIndex !== null) {
      var _b$options$b$activeOp = b.options[b.activeOptionIndex],
          p = _b$options$b$activeOp.dataRef,
          T = _b$options$b$activeOp.id;
      j(p.current.value), oe.goToOption(R.Specific, T);
    }
  }),
      S = x(function () {
    c({
      type: 0
    }), C.current = !0;
  }),
      X = x(function () {
    c({
      type: 1
    }), C.current = !1;
  }),
      q = x(function (p, T, v) {
    return C.current = !1, p === R.Specific ? c({
      type: 2,
      focus: R.Specific,
      id: T,
      trigger: v
    }) : c({
      type: 2,
      focus: p,
      trigger: v
    });
  }),
      Q = x(function (p, T) {
    return c({
      type: 3,
      id: p,
      dataRef: T
    }), function () {
      var v;
      ((v = L.current) == null ? void 0 : v.id) === p && (C.current = !0), c({
        type: 4,
        id: p
      });
    };
  }),
      Y = x(function (p) {
    return c({
      type: 5,
      id: p
    }), function () {
      return c({
        type: 5,
        id: null
      });
    };
  }),
      j = x(function (p) {
    var _U2;

    return U(b.mode, (_U2 = {}, _defineProperty(_U2, 0, function _() {
      return m == null ? void 0 : m(p);
    }), _defineProperty(_U2, 1, function _() {
      var T = b.value.slice(),
          v = T.findIndex(function (J) {
        return V(J, p);
      });
      return v === -1 ? T.push(p) : T.splice(v, 1), m == null ? void 0 : m(T);
    }), _U2));
  }),
      oe = D(function () {
    return {
      onChange: j,
      registerOption: Q,
      registerLabel: Y,
      goToOption: q,
      closeCombobox: X,
      openCombobox: S,
      selectActiveOption: I,
      selectOption: a
    };
  }, []),
      ce = l === null ? {} : {
    ref: l
  },
      Z = E(null),
      Te = ne();
  return se(function () {
    Z.current && r !== void 0 && Te.addEventListener(Z.current, "reset", function () {
      j(r);
    });
  }, [Z, j]), z.createElement(ae.Provider, {
    value: oe
  }, z.createElement(le.Provider, {
    value: b
  }, z.createElement(Fe, {
    value: U(b.comboboxState, (_U3 = {}, _defineProperty(_U3, 0, ee.Open), _defineProperty(_U3, 1, ee.Closed), _U3))
  }, s != null && O != null && Se(_defineProperty({}, s, O)).map(function (_ref, v) {
    var _ref2 = _slicedToArray(_ref, 2),
        p = _ref2[0],
        T = _ref2[1];

    return z.createElement(Le, _objectSpread({
      features: Ve.Hidden,
      ref: v === 0 ? function (J) {
        var ie;
        Z.current = (ie = J == null ? void 0 : J.closest("form")) != null ? ie : null;
      } : void 0
    }, Ae({
      key: p,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      name: p,
      value: T
    })));
  }), w({
    ourProps: ce,
    theirProps: f,
    slot: y,
    defaultTag: Ge,
    name: "Combobox"
  }))));
}

var je = "input";

function Je(t, l) {
  var G, b, L, y;

  var e = K(),
      _t$id = t.id,
      r = _t$id === void 0 ? "headlessui-combobox-input-".concat(e) : _t$id,
      i = t.onChange,
      s = t.displayValue,
      _t$type = t.type,
      n = _t$type === void 0 ? "text" : _t$type,
      d = _objectWithoutProperties(t, _excluded2),
      o = H("Combobox.Input"),
      u = $("Combobox.Input"),
      P = W(o.inputRef, l),
      f = E(!1),
      O = ne(),
      m = function () {
    var a;
    return typeof s == "function" && o.value !== void 0 ? (a = s(o.value)) != null ? a : "" : typeof o.value == "string" ? o.value : "";
  }();

  fe(function (_ref3, _ref4) {
    var _ref5 = _slicedToArray(_ref3, 2),
        a = _ref5[0],
        I = _ref5[1];

    var _ref6 = _slicedToArray(_ref4, 2),
        S = _ref6[0],
        X = _ref6[1];

    f.current || o.inputRef.current && (X === 0 && I === 1 || a !== S) && (o.inputRef.current.value = a);
  }, [m, o.comboboxState]), fe(function (_ref7, _ref8) {
    var _ref9 = _slicedToArray(_ref7, 1),
        a = _ref9[0];

    var _ref10 = _slicedToArray(_ref8, 1),
        I = _ref10[0];

    if (a === 0 && I === 1) {
      var S = o.inputRef.current;
      if (!S) return;
      var X = S.value,
          q = S.selectionStart,
          Q = S.selectionEnd,
          Y = S.selectionDirection;
      S.value = "", S.value = X, Y !== null ? S.setSelectionRange(q, Q, Y) : S.setSelectionRange(q, Q);
    }
  }, [o.comboboxState]);

  var g = E(!1),
      c = x(function () {
    g.current = !0;
  }),
      C = x(function () {
    setTimeout(function () {
      g.current = !1;
    });
  }),
      N = x(function (a) {
    var _U4, _U5;

    switch (f.current = !0, a.key) {
      case A.Backspace:
      case A.Delete:
        if (o.mode !== 0 || !o.nullable) return;
        var I = a.currentTarget;
        O.requestAnimationFrame(function () {
          I.value === "" && (u.onChange(null), o.optionsRef.current && (o.optionsRef.current.scrollTop = 0), u.goToOption(R.Nothing));
        });
        break;

      case A.Enter:
        if (f.current = !1, o.comboboxState !== 0 || g.current) return;

        if (a.preventDefault(), a.stopPropagation(), o.activeOptionIndex === null) {
          u.closeCombobox();
          return;
        }

        u.selectActiveOption(), o.mode === 0 && u.closeCombobox();
        break;

      case A.ArrowDown:
        return f.current = !1, a.preventDefault(), a.stopPropagation(), U(o.comboboxState, (_U4 = {}, _defineProperty(_U4, 0, function _() {
          u.goToOption(R.Next);
        }), _defineProperty(_U4, 1, function _() {
          u.openCombobox();
        }), _U4));

      case A.ArrowUp:
        return f.current = !1, a.preventDefault(), a.stopPropagation(), U(o.comboboxState, (_U5 = {}, _defineProperty(_U5, 0, function _() {
          u.goToOption(R.Previous);
        }), _defineProperty(_U5, 1, function _() {
          u.openCombobox(), O.nextFrame(function () {
            o.value || u.goToOption(R.Last);
          });
        }), _U5));

      case A.Home:
        if (a.shiftKey) break;
        return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption(R.First);

      case A.PageUp:
        return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption(R.First);

      case A.End:
        if (a.shiftKey) break;
        return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption(R.Last);

      case A.PageDown:
        return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption(R.Last);

      case A.Escape:
        return f.current = !1, o.comboboxState !== 0 ? void 0 : (a.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && a.stopPropagation(), u.closeCombobox());

      case A.Tab:
        if (f.current = !1, o.comboboxState !== 0) return;
        o.mode === 0 && u.selectActiveOption(), u.closeCombobox();
        break;
    }
  }),
      F = x(function (a) {
    u.openCombobox(), i == null || i(a);
  }),
      _ = x(function () {
    f.current = !1;
  }),
      h = te(function () {
    if (o.labelId) return [o.labelId].join(" ");
  }, [o.labelId]),
      B = D(function () {
    return {
      open: o.comboboxState === 0,
      disabled: o.disabled
    };
  }, [o]),
      V = {
    ref: P,
    id: r,
    role: "combobox",
    type: n,
    "aria-controls": (G = o.optionsRef.current) == null ? void 0 : G.id,
    "aria-expanded": o.disabled ? void 0 : o.comboboxState === 0,
    "aria-activedescendant": o.activeOptionIndex === null || (b = o.options[o.activeOptionIndex]) == null ? void 0 : b.id,
    "aria-labelledby": h,
    "aria-autocomplete": "list",
    defaultValue: (y = (L = t.defaultValue) != null ? L : o.defaultValue !== void 0 ? s == null ? void 0 : s(o.defaultValue) : null) != null ? y : o.defaultValue,
    disabled: o.disabled,
    onCompositionStart: c,
    onCompositionEnd: C,
    onKeyDown: N,
    onChange: F,
    onBlur: _
  };

  return w({
    ourProps: V,
    theirProps: d,
    slot: B,
    defaultTag: je,
    name: "Combobox.Input"
  });
}

var Ke = "button";

function We(t, l) {
  var g;

  var e = H("Combobox.Button"),
      r = $("Combobox.Button"),
      i = W(e.buttonRef, l),
      s = K(),
      _t$id2 = t.id,
      n = _t$id2 === void 0 ? "headlessui-combobox-button-".concat(s) : _t$id2,
      d = _objectWithoutProperties(t, _excluded3),
      o = ne(),
      u = x(function (c) {
    switch (c.key) {
      case A.ArrowDown:
        return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && r.openCombobox(), o.nextFrame(function () {
          var C;
          return (C = e.inputRef.current) == null ? void 0 : C.focus({
            preventScroll: !0
          });
        });

      case A.ArrowUp:
        return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && (r.openCombobox(), o.nextFrame(function () {
          e.value || r.goToOption(R.Last);
        })), o.nextFrame(function () {
          var C;
          return (C = e.inputRef.current) == null ? void 0 : C.focus({
            preventScroll: !0
          });
        });

      case A.Escape:
        return e.comboboxState !== 0 ? void 0 : (c.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && c.stopPropagation(), r.closeCombobox(), o.nextFrame(function () {
          var C;
          return (C = e.inputRef.current) == null ? void 0 : C.focus({
            preventScroll: !0
          });
        }));

      default:
        return;
    }
  }),
      P = x(function (c) {
    if (Ee(c.currentTarget)) return c.preventDefault();
    e.comboboxState === 0 ? r.closeCombobox() : (c.preventDefault(), r.openCombobox()), o.nextFrame(function () {
      var C;
      return (C = e.inputRef.current) == null ? void 0 : C.focus({
        preventScroll: !0
      });
    });
  }),
      f = te(function () {
    if (e.labelId) return [e.labelId, n].join(" ");
  }, [e.labelId, n]),
      O = D(function () {
    return {
      open: e.comboboxState === 0,
      disabled: e.disabled,
      value: e.value
    };
  }, [e]),
      m = {
    ref: i,
    id: n,
    type: Re(t, e.buttonRef),
    tabIndex: -1,
    "aria-haspopup": "listbox",
    "aria-controls": (g = e.optionsRef.current) == null ? void 0 : g.id,
    "aria-expanded": e.disabled ? void 0 : e.comboboxState === 0,
    "aria-labelledby": f,
    disabled: e.disabled,
    onClick: P,
    onKeyDown: u
  };

  return w({
    ourProps: m,
    theirProps: d,
    slot: O,
    defaultTag: Ke,
    name: "Combobox.Button"
  });
}

var $e = "label";

function qe(t, l) {
  var e = K(),
      _t$id3 = t.id,
      r = _t$id3 === void 0 ? "headlessui-combobox-label-".concat(e) : _t$id3,
      i = _objectWithoutProperties(t, _excluded4),
      s = H("Combobox.Label"),
      n = $("Combobox.Label"),
      d = W(s.labelRef, l);

  M(function () {
    return n.registerLabel(r);
  }, [r]);
  var o = x(function () {
    var f;
    return (f = s.inputRef.current) == null ? void 0 : f.focus({
      preventScroll: !0
    });
  }),
      u = D(function () {
    return {
      open: s.comboboxState === 0,
      disabled: s.disabled
    };
  }, [s]);
  return w({
    ourProps: {
      ref: d,
      id: r,
      onClick: o
    },
    theirProps: i,
    slot: u,
    defaultTag: $e,
    name: "Combobox.Label"
  });
}

var Qe = "ul",
    Ye = de.RenderStrategy | de.Static;

function Ze(t, l) {
  var e = K(),
      _t$id4 = t.id,
      r = _t$id4 === void 0 ? "headlessui-combobox-options-".concat(e) : _t$id4,
      _t$hold = t.hold,
      i = _t$hold === void 0 ? !1 : _t$hold,
      s = _objectWithoutProperties(t, _excluded5),
      n = H("Combobox.Options"),
      d = W(n.optionsRef, l),
      o = De(),
      u = function () {
    return o !== null ? (o & ee.Open) === ee.Open : n.comboboxState === 0;
  }();

  M(function () {
    var m;
    n.optionsPropsRef.current.static = (m = t.static) != null ? m : !1;
  }, [n.optionsPropsRef, t.static]), M(function () {
    n.optionsPropsRef.current.hold = i;
  }, [n.optionsPropsRef, i]), ve({
    container: n.optionsRef.current,
    enabled: n.comboboxState === 0,
    accept: function accept(m) {
      return m.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : m.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(m) {
      m.setAttribute("role", "none");
    }
  });
  var P = te(function () {
    var m, g;
    return (g = n.labelId) != null ? g : (m = n.buttonRef.current) == null ? void 0 : m.id;
  }, [n.labelId, n.buttonRef.current]),
      f = D(function () {
    return {
      open: n.comboboxState === 0
    };
  }, [n]),
      O = {
    "aria-labelledby": P,
    role: "listbox",
    "aria-multiselectable": n.mode === 1 ? !0 : void 0,
    id: r,
    ref: d
  };
  return w({
    ourProps: O,
    theirProps: s,
    slot: f,
    defaultTag: Qe,
    features: Ye,
    visible: u,
    name: "Combobox.Options"
  });
}

var ze = "li";

function eo(t, l) {
  var b, L;

  var e = K(),
      _t$id5 = t.id,
      r = _t$id5 === void 0 ? "headlessui-combobox-option-".concat(e) : _t$id5,
      _t$disabled2 = t.disabled,
      i = _t$disabled2 === void 0 ? !1 : _t$disabled2,
      s = t.value,
      n = _objectWithoutProperties(t, _excluded6),
      d = H("Combobox.Option"),
      o = $("Combobox.Option"),
      u = d.activeOptionIndex !== null ? d.options[d.activeOptionIndex].id === r : !1,
      P = d.isSelected(s),
      f = E(null),
      O = ge({
    disabled: i,
    value: s,
    domRef: f,
    textValue: (L = (b = f.current) == null ? void 0 : b.textContent) == null ? void 0 : L.toLowerCase()
  }),
      m = W(l, f),
      g = x(function () {
    return o.selectOption(r);
  });

  M(function () {
    return o.registerOption(r, O);
  }, [O, r]);
  var c = E(!d.__demoMode);
  M(function () {
    if (!d.__demoMode) return;
    var y = be();
    return y.requestAnimationFrame(function () {
      c.current = !0;
    }), y.dispose;
  }, []), M(function () {
    if (d.comboboxState !== 0 || !u || !c.current || d.activationTrigger === 0) return;
    var y = be();
    return y.requestAnimationFrame(function () {
      var a, I;
      (I = (a = f.current) == null ? void 0 : a.scrollIntoView) == null || I.call(a, {
        block: "nearest"
      });
    }), y.dispose;
  }, [f, u, d.comboboxState, d.activationTrigger, d.activeOptionIndex]);

  var C = x(function (y) {
    if (i) return y.preventDefault();
    g(), d.mode === 0 && o.closeCombobox(), he() || requestAnimationFrame(function () {
      var a;
      return (a = d.inputRef.current) == null ? void 0 : a.focus();
    });
  }),
      N = x(function () {
    if (i) return o.goToOption(R.Nothing);
    o.goToOption(R.Specific, r);
  }),
      F = _e(),
      _ = x(function (y) {
    return F.update(y);
  }),
      h = x(function (y) {
    F.wasMoved(y) && (i || u || o.goToOption(R.Specific, r, 0));
  }),
      B = x(function (y) {
    F.wasMoved(y) && (i || u && (d.optionsPropsRef.current.hold || o.goToOption(R.Nothing)));
  }),
      V = D(function () {
    return {
      active: u,
      selected: P,
      disabled: i
    };
  }, [u, P, i]);

  return w({
    ourProps: {
      id: r,
      ref: m,
      role: "option",
      tabIndex: i === !0 ? void 0 : -1,
      "aria-disabled": i === !0 ? !0 : void 0,
      "aria-selected": P,
      disabled: void 0,
      onClick: C,
      onFocus: N,
      onPointerEnter: _,
      onMouseEnter: _,
      onPointerMove: h,
      onMouseMove: h,
      onPointerLeave: B,
      onMouseLeave: B
    },
    theirProps: n,
    slot: V,
    defaultTag: ze,
    name: "Combobox.Option"
  });
}

var oo = k(Xe),
    to = k(We),
    no = k(Je),
    ro = k(qe),
    ao = k(Ze),
    lo = k(eo),
    Ko = Object.assign(oo, {
  Input: no,
  Button: to,
  Label: ro,
  Options: ao,
  Option: lo
});
export { Ko as Combobox };